(() => {
  const aliases = {"vanilla dust": "matiere premiere vanilla powder vanilla", "vanilla latte": "giardini di toscana bianco latte vanilla", "dark ocean": "lorenzo pazzaglia black sea aquatic marine", "desert tonka": "montale arabians tonka tonka", "night club": "armaf club de nuit intense man", "citrus boise": "mancera cedrat boise citrus", "genius ginger": "goldfield banks ingenious ginger ginger", "musk powder": "attar al has skin musk musk", "grande clouds": "ariana grande cloud", "miss d": "dior miss dior", "sungria soaked": "lorenzo pazzaglia sun gria sangria", "summer smasher": "lorenzo pazzaglia summer hammer fruity tropical", "vanished cherry": "tom ford lost cherry cherry", "silence": "lorenzo pazzaglia speechless", "wifey": "second wife", "aqua man": "ex nihilo blue talisman", "famous": "paco rabanne fame", "freaky": "byredo bal d afrique baldafrique", "dark wood": "penhaligons halfeti", "red 540": "maison francis kurkdjian baccarat rouge 540 br540", "zanzibar stories": "memoirs of a perfume collector tales from zanzibar", "jolly dust": "narcotica happy dust", "city stars": "clive christian town and country", "apex": "creed aventus", "sporty": "chanel allure homme sport", "martian": "mugler alien", "midnight tonka": "jo malone myrrh and tonka", "taormina tangerine": "tom ford mandarin di amalfi orange tangerine"};

  const normalize = (value = '') => value
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const money = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
  };

  document.querySelectorAll('[data-echo-predictive-search]').forEach((root) => {
    if (root.dataset.echoSearchReady === 'true') return;
    root.dataset.echoSearchReady = 'true';

    const input = root.querySelector('[data-echo-search-input]');
    const results = root.querySelector('[data-echo-search-results]');
    const form = root.querySelector('[data-echo-search-form]');
    const indexNode = root.querySelector('[data-echo-product-index]');
    if (!input || !results || !form || !indexNode) return;

    let products = [];
    try { products = JSON.parse(indexNode.textContent || '[]'); } catch (e) { console.error(e); }

    const close = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const scoreProduct = (product, query) => {
      const q = normalize(query);
      const title = normalize(product.title);
      const alias = aliases[title] || '';
      // Search only the Echo product name plus its original fragrance/brand alias.
      // Do not search descriptions, tags, handles or variants: those fields can contain
      // unrelated fragrance names and caused products such as Vanilla Dust to match everything.
      const haystack = `${title} ${alias}`;

      if (!q) return -1;
      if (title === q) return 100;
      if (title.startsWith(q)) return 90;
      if (title.includes(q)) return 80;
      if (alias.includes(q)) return 75;
      const terms = q.split(/\s+/).filter(Boolean);
      if (terms.every(term => haystack.includes(term))) return 60;
      return -1;
    };

    const pickSizeVariant = (product) => {
      const variants = (product.variants || []).filter(v => v.available);
      return variants.find(v => normalize(v.title).includes('15ml'))
        || variants.find(v => normalize(v.title).includes('30ml'))
        || variants[0]
        || (product.variants || [])[0]
        || null;
    };

    const addToCart = async (variant, button) => {
      if (!variant || !variant.id || button.dataset.busy === 'true') return;
      button.dataset.busy = 'true';
      const original = button.textContent;
      button.textContent = 'Adding…';
      button.disabled = true;
      try {
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${base}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Could not add item');
        button.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(() => {
          button.textContent = 'Add';
          button.disabled = false;
          button.dataset.busy = 'false';
        }, 1500);
      } catch (e) {
        console.error(e);
        button.textContent = 'Try again';
        button.disabled = false;
        button.dataset.busy = 'false';
        setTimeout(() => button.textContent = original || 'Add', 1500);
      }
    };

    const render = (query) => {
      const q = normalize(query);
      results.innerHTML = '';

      if (q.length < 2) {
        close();
        return;
      }

      let matched = products
        .map(product => ({ product, score: scoreProduct(product, q) }))
        .filter(item => item.score >= 0);

      // HYBRID contains all fragrance names as variants. Only show it when
      // the customer is actually searching for a hybrid.
      if (!q.includes('hybrid')) {
        matched = matched.filter(item => !normalize(item.product.title).includes('hybrid'));
      }

      matched.sort((a,b) => b.score - a.score || a.product.title.localeCompare(b.product.title));
      matched = matched.slice(0, 10);

      if (!matched.length) {
        const empty = document.createElement('div');
        empty.className = 'echo-home-search__empty';
        empty.textContent = `No fragrance found for “${query}”`;
        results.appendChild(empty);
      } else {
        const heading = document.createElement('div');
        heading.className = 'echo-home-search__results-title';
        heading.textContent = 'Matching fragrances';
        results.appendChild(heading);

        matched.forEach(({product}) => {
          const row = document.createElement('div');
          row.className = 'echo-home-search__result-row';

          const link = document.createElement('a');
          link.className = 'echo-home-search__result';
          link.href = product.url;
          link.setAttribute('role', 'option');

          if (product.image) {
            const img = document.createElement('img');
            img.className = 'echo-home-search__result-image';
            img.src = product.image;
            img.alt = '';
            img.loading = 'lazy';
            link.appendChild(img);
          } else {
            const fallback = document.createElement('div');
            fallback.className = 'echo-home-search__result-image echo-home-search__result-image--empty';
            link.appendChild(fallback);
          }

          const copy = document.createElement('div');
          copy.className = 'echo-home-search__result-copy';

          const title = document.createElement('strong');
          title.textContent = product.title;
          copy.appendChild(title);

          const sizes = (product.variants || [])
            .filter(v => v.available)
            .map(v => v.title)
            .filter(Boolean)
            .join(' • ');
          if (sizes) {
            const meta = document.createElement('span');
            meta.className = 'echo-home-search__result-variant';
            meta.textContent = sizes;
            copy.appendChild(meta);
          }

          link.appendChild(copy);
          row.appendChild(link);

          const variant = pickSizeVariant(product);
          if (variant) {
            const add = document.createElement('button');
            add.type = 'button';
            add.className = 'echo-home-search__add';
            add.textContent = 'Add';
            add.title = `Add ${variant.title}`;
            add.addEventListener('click', () => addToCart(variant, add));
            row.appendChild(add);
          }

          results.appendChild(row);
        });
      }

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => render(input.value), 120);
    });

    if (input.value.trim().length >= 2) {
      setTimeout(() => render(input.value), 50);
    }

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) render(input.value);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      render(input.value);
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) close();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  });
})();
